import React, { memo } from 'react'
export type ProposalStep = 1 | 2 | 3 | 4;
  interface StepperProps {
    currentStep: ProposalStep;
    completedStep: number;
    onStepClick: (step: ProposalStep) => void;
    clickDisable?:boolean
  }

  const stepLabels = ["Roof Confirmation", "Electricity Consumption", "Utility & Tariff", "Review & Submit"];

export  const ProgressStepper = memo(({ currentStep, completedStep, onStepClick ,clickDisable = false}: StepperProps) => {
    return (
      <div className="flex w-full bg-white px-5 pt-3 pb-2 gap-2">
        {stepLabels.map((label, index) => {
          const step = (index + 1) as ProposalStep;
          const isCompleted = step <= completedStep;
          const isActive = step === currentStep;
          const isClickable = isCompleted || step === completedStep + 1;
          
          return (
            <div key={label} onClick={() => isClickable && onStepClick(step)} className={`flex flex-col gap-2 flex-1 ${isClickable && !clickDisable ? 'cursor-pointer' : 'cursor-default'}`}>
              <div className={["h-[4px] w-full transition-all duration-300", (isActive || isCompleted) ? "bg-custom-primary-dark" : "bg-gray-400",].join(" ")} />
              <span className={["text-[11px] flex justify-center", (isActive || isCompleted) ? "text-custom-primary-dark" : "text-gray-400", isActive ? "font-semibold" : "font-normal",].join(" ")} >
                {label}
              </span>
            </div>
          );
        })}
      </div>
    );
  })